module.exports = __webpack_public_path__ + "img/18.7a03a56a.jpg";